var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DC2566D4-6C34-4976-8469-9CFA1DAAC89A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Approved-Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location-existing-flow-3e",
    transform: "translate(-768.000000, -474.000000)",
    fill: "#9B9B9B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(368.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(20.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 256.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input-box"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(380.000000, 0.000000)",
    id: "Group-36"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-page-home"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.690857326,10.5866621 L2.31993285,10.5866621 L2.31993285,17.0818647 C2.31993285,17.4646169 2.63410906,17.7777778 3.01810221,17.7777778 L7.78893984,17.7777778 C8.17293299,17.7777778 8.4871092,17.4646169 8.4871092,17.0818647 L8.4871092,12.3264448 L11.3961345,12.3264448 L11.3961345,17.0818647 C11.3961345,17.4646169 11.7103107,17.7777778 12.0943039,17.7777778 L16.6324047,17.7777778 C17.0163978,17.7777778 17.330574,17.4646169 17.330574,17.0818647 L17.330574,10.5866621 L19.3087342,10.5866621 C19.588002,10.5866621 19.8439837,10.4126838 19.9487091,10.1575293 C20.0534345,9.90237484 19.9952401,9.60079885 19.7974528,9.40360983 L10.6979651,0.205972 C10.4303199,-0.0608083337 9.98817332,-0.07239324 9.72052804,0.194387094 L0.213802311,9.39202492 C0.00435150349,9.58921395 -0.0538429659,9.890749 0.0508824378,10.1575293 C0.155607841,10.4242687 0.411589583,10.5866621 0.690857326,10.5866621 Z M10.1859606,1.67897442 L17.6330867,9.1948359 L16.6323636,9.1948359 C16.2483705,9.1948359 15.9341943,9.50799679 15.9341943,9.890749 L15.9341943,16.3859516 L12.7924322,16.3859516 L12.7924322,11.6305317 C12.7924322,11.2477795 12.4782559,10.9346186 12.0942628,10.9346186 L7.78893984,10.9346186 C7.4049467,10.9346186 7.09077049,11.2477795 7.09077049,11.6305317 L7.09077049,16.3859516 L3.71627157,16.3859516 L3.71627157,9.890749 C3.71627157,9.50799679 3.40209536,9.1948359 3.01810221,9.1948359 L2.41303579,9.1948359 L10.1859606,1.67897442 Z",
    id: "Shape"
  }))))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.4cbfe918e72aa22cf2c5ea8497f9cb2c.svg";
export { ForwardRef as ReactComponent };